<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-container class="whitesmoke" fluid>
    <v-row class="whitesmoke tab" no-gutters>
        <v-alert
            v-if="device?.data?.properties?.mb === undefined"
            color="error"
            class="mx-1"
            dense
            outlined
            icon="mdi-alert-circle-outline"
            type="error"
            >
            {{$t('comboNoData')}}
        </v-alert>
    </v-row>
    <v-row v-if="device?.data?.properties?.mb !== undefined" class="whitesmoke tab" no-gutters>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_r !== undefined"
            :title="$t('indoor_temperature')"
            :title_number="device?.data?.properties?.mb?.t_r?.toFixed(1)"
            text_font_size="20px"
            card_icon="mdi-home"
            unit="celsius"
            card_icon_color="green"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_r_set !== undefined"
            :title="$t('room_target')"
            :title_number="device?.data?.properties?.mb?.t_r_set?.toFixed(1)"
            text_font_size="20px"
            card_icon="mdi-home-thermometer"
            unit="celsius"
            card_icon_color="cyan"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_out !== undefined"
            :title="$t('outdoor_temperature')"
            :title_number="device?.data?.properties?.mb?.t_out?.toFixed(1)"
            text_font_size="20px"
            card_icon="mdi-cloud"
            unit="celsius"
            card_icon_color="blue"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_water_out !== undefined && device?.data?.properties?.mb?.t_set !== undefined"
            :title="$t('t_water_out')"
            :title_number="device?.data?.properties?.mb?.t_water_out?.toFixed(1)"
            :subTitle="$t('target') + ': ' + device?.data?.properties?.mb?.t_set?.toFixed(1)"
            text_font_size="20px"
            card_icon="mdi-radiator"
            unit="celsius"
            card_icon_color="red"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_water_out !== undefined && device?.data?.properties?.mb?.t_ch1_set !== undefined"
            :title="$t('t_water_out')"
            :title_number="device?.data?.properties?.mb?.t_water_out?.toFixed(1)"
            :subTitle="$t('target') + ': ' + heatpumpTargetSetpoint"
            text_font_size="20px"
            card_icon="mdi-radiator"
            unit="celsius"
            card_icon_color="red"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_water_in !== undefined"
            :title="$t('t_water_in')"
            :title_number="device?.data?.properties?.mb?.t_water_in?.toFixed(1)"
            text_font_size="20px"
            card_icon="mdi-radiator"
            unit="celsius"
            card_icon_color="blue"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.t_dhw !== undefined"
            :title="$t('max_hot_water_temperature')"
            :title_number="device?.data?.properties?.mb?.t_dhw?.toFixed(1)"
            :subTitle="$t('target') + ': ' + device?.data?.properties?.mb?.t_dhw_set?.toFixed(1)"
            text_font_size="20px"
            card_icon="mdi-water"
            unit="celsius"
            card_icon_color="blue"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.op_mode !== undefined"
            :title="$t('heatpump_operation_status')"
            :title_number="$t(getHeatPumpOperationModeText(device?.data?.properties?.mb?.op_mode))"
            text_font_size="20px"
            :card_icon="getHeatPumpOperationModeIcon(device?.data?.properties?.mb?.op_mode)"
            :card_icon_color="getHeatPumpOperationModeColor(device?.data?.properties?.mb?.op_mode)"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.error_code !== undefined"
            :title="$t('heatpump_status')"
            :title_number="device?.data?.properties?.mb?.error_code ? device?.data?.properties?.mb?.error_code  : '' "
            text_font_size="20px"
            :card_icon="device?.data?.properties?.mb?.error_code ? 'mdi-alert-outline' : 'mdi-heart'"
            :card_icon_color="device?.data?.properties?.mb?.error_code ? 'warning' : 'green'"
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.heat_set !== undefined"
            :title="$t('heatpump_status')"
            :title_number="heatpumpCtlMod ? $t('ON_female') : $t('OFF_female')"
            :subTitle="$t('compressor') + ': ' + (device?.data?.properties?.mb?.cmp ? $t('ON_male') : $t('OFF_male'))"
            text_font_size="20px"
            :card_icon="'mdi-heat-pump-outline'"
            :card_icon_color="device?.data?.properties?.mb?.heat_set ? 'deep-orange' : 'indigo' "
        ></DeviceOverviewCard>
        <DeviceOverviewCard
            v-if="device?.data?.properties?.mb?.heat !== undefined"
            :title="$t('circulator')"
            :title_number="device?.data?.properties?.mb?.heat ? $t('ON_male') : $t('OFF_male')"
            text_font_size="20px"
            :card_icon="device?.data?.properties?.mb?.heat ? 'mdi-pump' : 'mdi-pump-off'"
            :card_icon_color="device?.data?.properties?.mb?.heat ? 'indigo' : 'gray' "
        ></DeviceOverviewCard>
    </v-row>
    <v-row v-if="device?.data?.properties?.mb !== undefined" no-gutters class="mt-5">
      <v-card>
        <v-card-title>
          {{$t('operation_parameters')}}
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-
            clearable
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="deviceMetrics"
          :search="search"
        >
      </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import DashboardCardBarChart from "@/components/Cards/DashboardCardBarChart.vue";
import DashboardCardPieChart from "@/components/Cards/DashboardCardPieChart.vue";
import DeviceOverviewCard from "@/components/Cards/DeviceOverviewCard.vue";
import DeviceOverviewSwitchCard from "@/components/Cards/DeviceOverviewSwitchCard.vue";
import DeviceOverviewButtonCard from "@/components/Cards/DeviceOverviewButtonCard.vue";
import DeviceOverviewHeatingBalanceSliderCard from "@/components/Cards/DeviceOverviewHeatingBalanceSliderCard.vue";
import DashboardCardFaultsPieChart from "@/components/Cards/DashboardCardFaultsPieChart.vue";
import DeviceOverviewRoomTargetCard from "@/components/Cards/DeviceOverviewRoomTargetCard.vue";
import { MBDeviceOperationMode } from '@/helpers/data';

@Component({
  components: {
    DashboardCardBarChart,
    DashboardCardPieChart,
    DeviceOverviewCard,
    DeviceOverviewSwitchCard,
    DeviceOverviewButtonCard,
    DeviceOverviewHeatingBalanceSliderCard,
    DeviceOverviewRoomTargetCard,
    DashboardCardFaultsPieChart,
  }
})

export default class MBGeneralView extends Vue {
  @Prop() device: Record<string, any>;

  search = '';
  tableHeaders = [
      {
        text: this.$t('name'),
        align: 'start',
        value: 'name',
      },
      { text: this.$t('value'), value: 'value' },
  ]


  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  getHeatPumpOperationModeText(op: number) {
    return MBDeviceOperationMode(op)["text"];
  }
  getHeatPumpOperationModeIcon(op: number) {
    return MBDeviceOperationMode(op)["icon"];
  }

  getHeatPumpOperationModeColor(op: number) {
    return MBDeviceOperationMode(op)["color"];
  }

  get deviceData () {
    return this.device.data.properties
  }

  get deviceMetrics() {
    return Object.entries(this.device?.data?.properties?.mb).filter(([key, value]) => !(key === 'time')).map(([key, value]) => {
        return { name: this.$t(key), value: value };
    }) 
  }

  get heatpumpTargetSetpoint() {

    if (this.deviceData?.mb?.h_cur_en || this.deviceData?.mb?.c_cur_en) {
      return this.deviceData?.mb?.cur_ch1?.toFixed(1)
    }
    else {
      return this.deviceData?.mb?.t_ch1_set?.toFixed(1)
    }
  }

  get heatpumpCtlMod() {
    return this.deviceData?.mb?.ctl_mod_t_r || this.deviceData?.mb?.ctl_mod_t_ch1 || this.deviceData?.mb?.ctl_mod_t_dhw || this.deviceData?.mb?.ctl_mod_t_ch2
  }


};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh - 230px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
